'use client'

import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./Modal.css";

interface ModalProps {
    message: string;
    onClose: () => void;
    modalRef: React.RefObject<HTMLDivElement | null>;
  }

const Modal: React.FC<ModalProps> = ({ message, onClose, modalRef }) => {
    useEffect(() => {
        if (modalRef.current) {
          modalRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, [modalRef]);

  return ReactDOM.createPortal(
    <div className="modal" ref={modalRef}>
      <div className="modal-content">
        <p tabIndex={0}>{message}</p>
        <button onClick={onClose} aria-label="Fechar modal e voltar">Voltar</button>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
